import React, { Component } from 'react';
import { withRouter } from 'react-router';
/* import { withFirebase } from 'react-redux-firebase';
 */import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Formik } from 'formik';
import { schemapass } from '../../extras/validation/schema';
import ButtonBase from '../../../../../../components/Buttons/ButtonBase';
import Footer from '../../Footer';
import '../../../index.scss';
// import { newPasswordAction } from '../../../../../../store/modules/auth';

const styles = () => ({
  colorGrayIcon: {
    color: '#c1c1c1',
    padding: 0
  },
  TextField: {
    maxWidth: '336px'
  }
});

class FormRecoverPassword extends Component {
  state = {
    showPassword: false,
    forgetPassword: false,
    open: false
  };

  changeState = () => {
    this.setState({ open: false });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handlerBack = () => {
    this.props.history.push('/');
  };
  renderFormResetPassword = props => {
    const {
      values,
      handleChange,
      handleSubmit,
      touched,
      dirty,
      handleBlur,
      errors,
      isValid
    } = props;
    const { classes } = this.props;

    return (
      <form className="container-box">
        <div className="container-main">
          <div>
            <div className="contenido-center-flex">
              <img src="/img/Logo-box.svg" alt="logo" />
            </div>
            <div className="contenido-center-flex">
              <p className="text-title-login">Restablecer tu xxxxx contraseña</p>
            </div>
            <div>
              <p className="text-main_restablecer">
                Las contraseñas xfuertes incluyen números, letras
              </p>
            </div>
          </div>

          <div>
            <div>
              <TextField
                label="Nueva Contraseña"
                type="password"
                id="password"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.password}
                helperText={
                  touched.password && errors.password ? errors.password : ''
                }
                error={touched.password && errors.password ? true : false}
              />
            </div>
            <div>
              <TextField
                label="Confirmar Contraseña"
                type="password"
                id="confirmPassword"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.confirmPassword}
                helperText={
                  touched.confirmPassword && errors.confirmPassword
                    ? errors.confirmPassword
                    : ''
                }
                error={
                  touched.confirmPassword && errors.confirmPassword
                    ? true
                    : false
                }
              />
            </div>
          </div>

          <div className="horizontal-layout" style={{ marginTop: 15 }}>
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
            // disabled={!isValid}
            >
              Enviars
            </ButtonBase>
          </div>
        </div>

        <Footer
          margin="8px 0px 16px"
          text="Si tienes cualquier duda o problema escribenos a:"
          textLink="hola@contactaabogado.com"
          linkTo=""
        />
      </form>
    );
  };






  onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    const { password } = values;
    let str = window.location.href;
    const link = str.split('Code=').pop();
    let apiKey = link.indexOf('&apiKey');

    let code = link.substr(0, apiKey);


    this.props.firebase.confirmPasswordReset(code, password)
      .then(res => {

        /* if (snap.user.user && snap.user.user.emailVerified) {
          this.props.history.push('/mi-cuenta/inicio');
        } */
        console.log('res' , res)
      })
      .catch(error => {
        console.log('error' , error)

        switch (error.code) {
          case 'auth/user-not-found':
            return setErrors({ email: 'Esta cuenta no existe' });
          case 'auth/wrong-password':
            return setErrors({ password: 'Esta contraseña es incorrecta' });
          case 'auth/too-many-requests':
            return setErrors({
              password: 'Limite de intentos porfavor espere un momento'
            });

          default:
            return setErrors({ email: 'Ocurrió un error' });
        }
      });
  };



  handleSubmit = async (values, actions) => {
    const { password } = values;
    let str = window.location.href;
    const link = str.split('Code=').pop();
    let apiKey = link.indexOf('&apiKey');

    let code = link.substr(0, apiKey);
    alert(code);
    this.props.firebase.confirmPasswordReset(code, password).then(res => {})
      .catch(error => error)
    /*  &apiKey=AIzaSyDc2P1H0Lp9JQC6t7N6to6KDJIRpeXZcZg
    &lang=es' */
    /* const { newPassword, history } = this.props;
    newPassword({ code, password }, history);
    this.props.firebase */


  };

  render() {
    const incialValuesTwo = {
      password: '',
      confirmPassword: ''
    };
    return (
      <Formik
        initialValues={incialValuesTwo}
        validationSchema={schemapass}
        onSubmit={this.onSubmit}
        render={this.renderFormResetPassword}
      />
    );
  }
}

/* const mapStateToProps = state => ({
  auth: state.auth
});
const mapDispatchToProps = dispatch => ({
  // newPassword: ({ code, password }, browserHistory) =>
  // dispatch(newPasswordAction({ code, password }, browserHistory))
}); */

export default withRouter(withStyles(styles)(FormRecoverPassword));
